import { ColumnPersonalizationFlags } from 'src/utils/columns/columnUtils.types';

export enum CampaignsTableColumnId {
  Campaign = 'campaign',
  EventName = 'eventName',
  EventDate = 'eventDate',
  StartDate = 'startDate',
  StartTime = 'startTime',
  EndDate = 'endDate',
  PotentialRevenue = 'potentialRevenue',
  Revenue = 'revenue',
  Spend = 'spend',
  Roas = 'roas',
  PotentialSales = 'potentialSales',
  SalesCount = 'salesCount',
  HistoricPotentialImpressions = 'historicPotentialImpressions',
  ActualImpressions = 'actualImpressions',
  ImpressionShare = 'impressionShare',
  Clicks = 'clicks',
  Cpc = 'cpc',
  Budget = 'budget',
  BudgetRemaining = 'budgetRemaining',
  Status = 'status',
  Target = 'target',
  Actions = 'actions',
}

type CampaignsTableColumnPersonalization = Partial<ColumnPersonalizationFlags>;

export const CAMPAIGNS_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES: Partial<
  Record<CampaignsTableColumnId, CampaignsTableColumnPersonalization>
> = {
  [CampaignsTableColumnId.Campaign]: {
    isConfigurable: true,
    isRequired: false,
  },
  [CampaignsTableColumnId.EventName]: {
    isConfigurable: true,
  },
  [CampaignsTableColumnId.EventDate]: {
    isConfigurable: true,
    isDateTime: true,
  },
  [CampaignsTableColumnId.StartDate]: {
    isConfigurable: true,
    isDateTime: true,
  },
  [CampaignsTableColumnId.StartTime]: {
    isConfigurable: true,
  },
  [CampaignsTableColumnId.EndDate]: {
    isConfigurable: true,
    isDateTime: true,
  },
  [CampaignsTableColumnId.PotentialRevenue]: {
    isConfigurable: true,
    isNumeric: true,
    isCurrency: true,
  },
  [CampaignsTableColumnId.Revenue]: {
    isConfigurable: true,
    isNumeric: true,
    isCurrency: true,
  },
  [CampaignsTableColumnId.Spend]: {
    isConfigurable: true,
    isNumeric: true,
    isCurrency: true,
  },
  [CampaignsTableColumnId.Roas]: {
    isConfigurable: true,
    isNumeric: true,
    isPercent: true,
  },
  [CampaignsTableColumnId.PotentialSales]: {
    isConfigurable: true,
    isNumeric: true,
    isInteger: true,
  },
  [CampaignsTableColumnId.SalesCount]: {
    isConfigurable: true,
    isNumeric: true,
    isInteger: true,
  },
  [CampaignsTableColumnId.HistoricPotentialImpressions]: {
    isConfigurable: true,
    isNumeric: true,
    isInteger: true,
  },
  [CampaignsTableColumnId.ActualImpressions]: {
    isConfigurable: true,
    isNumeric: true,
    isInteger: true,
  },
  [CampaignsTableColumnId.ImpressionShare]: {
    isConfigurable: true,
    isNumeric: true,
    isPercent: true,
  },
  [CampaignsTableColumnId.Clicks]: {
    isConfigurable: true,
    isNumeric: true,
    isInteger: true,
  },
  [CampaignsTableColumnId.Cpc]: {
    isConfigurable: true,
    isNumeric: true,
    isCurrency: true,
  },
  [CampaignsTableColumnId.Budget]: {
    isConfigurable: true,
    isNumeric: true,
    isCurrency: true,
  },
  [CampaignsTableColumnId.BudgetRemaining]: {
    isConfigurable: true,
    isNumeric: true,
    isCurrency: true,
  },
  [CampaignsTableColumnId.Status]: {
    isConfigurable: true,
  },
  [CampaignsTableColumnId.Target]: {
    isConfigurable: true,
  },
  [CampaignsTableColumnId.Actions]: {
    isConfigurable: false,
    isRequired: true,
  },
};
